import { NumRange } from './range';
import { DurationRange } from './duration';

export class RepeatSettings {
    times: NumRange;
    every: DurationRange;

    constructor(times: NumRange, every: DurationRange) {
        this.times = times;
        this.every = every;
    }

    public static fromRaw(rawData: any): RepeatSettings {
        return new RepeatSettings(
            rawData.times !== undefined ? NumRange.fromRaw(rawData.times) : NumRange.ONE(),
            rawData.every !== undefined ? DurationRange.fromRaw(rawData.every) : DurationRange.ZERO(),
        )
    }

    public setEvery(mutator: (DurationRange) => DurationRange) {
        this.every = mutator(this.every);
    }

    public setTimes(mutator: (NumRange) => (NumRange)) {
        this.times = mutator(this.times);
    }

    public isLooping(): boolean {
        return this.equals(_LOOP_FOR_COMPARING);
    }

    public equals(other: RepeatSettings): boolean {
        return this.every.equals(other.every) && this.times.equals(other.times);
    }

    // This needs to return a new instance every time, otherwise we get into the case of:
    // const a = LOOP;
    // a.modify();
    // Now LOOP is modified.
    // Long live immutable.
    public static LOOP(): RepeatSettings {
        return new RepeatSettings(
            NumRange.ONE(),
            DurationRange.ZERO(),
        );
    }
}
const _LOOP_FOR_COMPARING = RepeatSettings.LOOP();
